'use client'

import { useQuery } from '@tanstack/react-query'

import { serviceOptions } from '../query/service-options'

/**
 * Справочник услуг вместе с состояниями показа: идёт загрузка, случился отказ, можно повторить.
 * Пустой справочник — законное состояние (поддержка ещё не завела услуги), отличается от отказа
 * сервера.
 */
export const useServiceOptions = () => {
  const query = useQuery(serviceOptions())
  const services = query.data
  // Загруженные данные не прячем из-за ошибки фонового обновления, а повтор считаем загрузкой.
  const hasLoadError = !services && query.isError && !query.isFetching

  return {
    services,
    isLoading: !services && !hasLoadError,
    hasLoadError,
    retry: () => {
      void query.refetch()
    },
  }
}
